import CampaignRequirements from "@/components/campaign-requirements/campaign-requirements";
import { RequirementsObjectiveProps, RenderObjectiveProps } from "./requirements-objective-types";
import { ALLOWED_OBJECTIVE_REQUIREMENTS } from "./utils";
import { useEffect, useState } from "react";

const RenderAllowedObjective: React.FC<RenderObjectiveProps> = ({ objective, setArrayCompletedRequirements, position }) => {
  const { type } = objective;
  const allowedType = type?.split(':')?.[0];
  if(!ALLOWED_OBJECTIVE_REQUIREMENTS.includes(allowedType)) {
    return <div style={{ color: 'white' }}> not allowed {allowedType} </div>
  }
  return (
    <CampaignRequirements 
      objective={objective} 
      setArrayCompletedRequirements={setArrayCompletedRequirements}
      position={position}
    />
  )
}

const RequirementsObjective: React.FC<RequirementsObjectiveProps> = ({ requirements, setCompletedRequirements }) => {
  const [arrayCompletedRequirements, setArrayCompletedRequirements] = useState<boolean[]>([]);
  
  useEffect(() => {
    const completed = arrayCompletedRequirements?.length > 0 && arrayCompletedRequirements?.every((value) => value === true);
    setCompletedRequirements(completed);
  }, [arrayCompletedRequirements, setCompletedRequirements]);

  return requirements?.map((objective, index) => {
    return (
      <RenderAllowedObjective 
        key={objective.id} 
        objective={objective} 
        setArrayCompletedRequirements={setArrayCompletedRequirements}
        position={index}
      />
    )
  })
}

export default RequirementsObjective;
